// for mock exam regis page
export const PAGE_GET_STARTED = '0';
export const PAGE_REGISTER_PARENT = '1.1';
export const PAGE_LOGIN_PARENT = '1.2';
export const PAGE_OTP = '1.3';
export const PAGE_MOCK_EXAM_FORGET = '1.4';
export const PAGE_ADD_STUDENT = '2';
export const PAGE_STUDENT_LIST = '3';
export const PAGE_BOOK_SESSIONS = '4';
export const PAGE_THANK_YOU = '5';
export const PAGE_MOCK_EXAM_CLOSED = '6';

// for webinar regis page
export const PAGE_WEBINAR_WELCOME = '0';
export const PAGE_WEBINAR_SELECT = '1';
export const PAGE_WEBINAR_PAYMENT = '2';
export const PAGE_WEBINAR_THANK_YOU = '3';
export const PAGE_WEBINAR_CLOSED = '4';

export const MOCK_EXAM_UID_KEY = 'mock_exam_uid';
export const MOCK_EXAM_STEP_KEY = 'mock_exam_step';
export const MOCK_EXAM_PARENT_DATA_KEY = 'mock_exam_parent_data';
export const MOCK_EXAM_STUDENTS_DATA_KEY = 'mock_exam_students_data';

export const MOCK_EXAM_LEVEL_OPTIONS = [
  { label: "Please select child's level", value: '-99' },
  { label: 'Primary 4', value: '4' },
  { label: 'Primary 5', value: '5' },
  { label: 'Secondary 1', value: '7' },
  { label: 'Secondary 2', value: '8' },
];

export const MOCK_EXAM_LEVEL_NAME = [
  { id: -99, name: '' },
  { id: 4, name: 'Primary 4' },
  { id: 5, name: 'Primary 5' },
  { id: 7, name: 'Secondary 1' },
  { id: 8, name: 'Secondary 2' },
];

export const CONTACT_SUPPORT_URL =
  'https://geniebook.atlassian.net/servicedesk/customer/portal/1/group/1/create/1';

export const SUBJECT_ID_MATH = 2;
export const LEVEL_PRIMARY_5 = 5;
export interface ICurrencySymbols {
  SGD: string;
  VND: string;
}

export const currencySymbols: ICurrencySymbols = {
  SGD: '$',
  VND: '₫',
};

export const TRANSACTION_STATUS_UNPAID = '0';
export const TRANSACTION_STATUS_SUCCESS = '1';
export const TRANSACTION_STATUS_PENDING = '2';
export const CURRENCY_CODE_VIETNAM = 'VND';
